<script setup lang="ts">
import { onlineCourseService } from '@/api/services/online-course-service'
import { useIsMobile } from '@/composables/useMediaQuery'
import type { OnlineCourse } from '@/types/online-course.types'
import { computed, onMounted, ref } from 'vue'
import OnlineClassListItem from './OnlineClassListItem.vue'

const isMobile = useIsMobile()

// 온라인 클래스 데이터
const onlineClassList = ref<OnlineCourse[]>([])

onMounted(async () => {
  const onlineCourses = await onlineCourseService.getOnlineCourses()
  onlineClassList.value = onlineCourses
})

const emptyText = computed(() => {
  return isMobile.value
    ? '진행 중이거나 예정된\n라이브 스트리밍이 없습니다.'
    : '진행 중이거나 예정된 라이브 스트리밍이 없습니다.'
})
</script>

<template>
  <div class="online-class-list">
    <OnlineClassListItem v-for="item in onlineClassList" :key="item.idx" :item="item" />

    <!-- 결과가 없는 경우 -->
    <div v-if="onlineClassList.length === 0" class="empty-state">
      <div class="empty-state-container">
        <div class="empty-state-icon-image">
          <img src="@/assets/svgs/cloud.svg" alt="empty-state-icon" />
        </div>
        <div class="empty-state-icon-text">
          <div class="title-sm white" :class="{ 'body-md': isMobile }">{{ emptyText }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.online-class-list {
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-top: 28px;
  align-items: center;
}

.empty-state {
  height: 100%;
  grid-column: 1 / -1;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 720px;
  max-height: 720px;
}

.empty-state-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.empty-state-icon-image {
  width: 80px;
  height: 80px;
}
.empty-state-icon-image img {
  width: 100%;
  height: 100%;
}

.empty-state-icon-text {
  margin-top: 12px;
}

.empty-state-icon-text div {
  white-space: pre-line;
}

@media (max-width: 1365px) {
  .online-class-list {
    grid-template-columns: 1fr;
    gap: 16px;
    margin-top: 0px;
  }

  .list-item:hover {
    transform: none;
    border: none;
  }

  .online-class-list:has(.list-item:hover) .list-item:not(:hover) {
    opacity: 1;
    transition: none;
  }
}
</style>
